import React from 'react';
import CartPage from '../components/CartPage';

const Cart = () => {
  return <CartPage />;
  
};

export default Cart;
